import { RadioGroup, RadioGroupItem, RadioGroupItemLabel } from "@/components/shadcn/radio-group";
import { TextFieldRoot, TextFieldLabel } from "@/components/shadcn/textfield";
import { RadioGroupItemControl } from "@/components/shadcn/radio-group";
import { For } from "solid-js";

export function RadioGroupInput(props) {

  const onInput = (value) => {
    props.input(props.name, value);
  }

  return (
    <TextFieldRoot>
      <TextFieldLabel class={props.sr ? 'sr-only' : ''}>{props.label}</TextFieldLabel>
      <RadioGroup value={props.form[props.name]} onChange={onInput} class="flex gap-3">
        <For each={props.options}>{(option) =>
          <RadioGroupItem value={option.value} class="flex items-center gap-1">
            <RadioGroupItemControl />
            <RadioGroupItemLabel>{option.text}</RadioGroupItemLabel>
          </RadioGroupItem>
        }</For>
      </RadioGroup>
    </TextFieldRoot>
  );
}
